
import ContactForm from '../components/ContactForm';
import PageHeader from "../components/PageHeader";

export default function Contact() {
    return (
        <>
            <PageHeader title="संपर्क साधा" path="contact" name="Contact" />
            <ContactForm />
        </>
    );
}